import { Directive, ElementRef, HostListener, Input, OnInit } from '@angular/core';

@Directive({
    selector: '[appFormatCustomfield]',
    standalone: false
})
export class FormatCustomfieldDirective implements OnInit {
  @Input() formatCustom: string | boolean | number | null | undefined;
  private formatValue: boolean | null = null;
  
  constructor(private elementRef: ElementRef) { }

  ngOnInit() {
    // Normalizar el valor de formatCustom a boolean o null
    if (this.formatCustom === null || this.formatCustom === undefined) {
      this.formatValue = null;
    } else {
      this.formatValue = this.formatCustom === true || String(this.formatCustom) === 'true' || Number(this.formatCustom) === 1 || String(this.formatCustom) === '1';
    }
    
    const element = this.elementRef.nativeElement;
    if (element.value) {
      this.change(element.value)
    }
  }
  
  @HostListener('keyup', ['$event.target'])
  keyupFun(evt) {
    if (evt.value) {
      this.change(evt.value.replace(this.getSimbol(), "").split(".").join("").trim())
    }
  }
  
  change(value) {
    if (this.formatValue === null || this.formatValue === undefined) {
      return; // No formatear si format es null
    }
    
    let options: Intl.NumberFormatOptions = this.formatValue ? { style: 'currency', currency: 'CLP' } : { style: 'decimal' };
    const numberFormat = new Intl.NumberFormat('es-CL', options);
    const numericValue = parseFloat(value.toString().replace(/[^0-9.,-]/g, '').replace(',', '.'));
    
    if (isNaN(numericValue)) {
      this.elementRef.nativeElement.value = '';
      return;
    }
    
    this.elementRef.nativeElement.value = numberFormat.format(numericValue);
  }
  
  getSimbol() {   
    return this.formatValue === null || this.formatValue === undefined ? '' : this.formatValue ? '$' : '%';
  }
}
